<template>
  <div>Logout</div>
</template>
<script>
export default {
  data() {
    return {};
  },
  async created() {
    await this.$mainstore.dispatch("security/logout");
  }
};
</script>
